var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.40 -646.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.51,646.4h8.57c.88,0,1.67.37,2.27.94.57.59.94,1.39.94,2.29v8.55c0,.9-.37,1.69-.94,2.29-.59.57-1.39.94-2.27.94h-8.57c-.88,0-1.69-.37-2.27-.94-.59-.59-.96-1.39-.96-2.29v-8.55c0-.9.37-1.69.96-2.29s1.39-.94,2.27-.94ZM27.75,658.52c-.24,0-.43-.18-.43-.41,0-.24.18-.43.43-.43h3.35c.24,0,.43.18.43.43,0,.22-.18.41-.43.41h-3.35ZM27.75,650.95c-.24,0-.43-.18-.43-.41,0-.24.18-.43.43-.43h9.24c.22,0,.41.18.41.43,0,.22-.18.41-.41.41h-9.24ZM27.75,653.48c-.24,0-.43-.18-.43-.43,0-.22.18-.41.43-.41h9.24c.22,0,.41.18.41.41,0,.24-.18.43-.41.43h-9.24ZM27.75,656.01c-.24,0-.43-.2-.43-.43s.18-.43.43-.43h3.35c.24,0,.43.2.43.43s-.18.43-.43.43h-3.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPrivacyPolicy);
export default __webpack_public_path__ + "static/media/sidebar_privacy_policy.c31f3a129bf65bdd0c2d5af90fdeb228.svg";
export { ForwardRef as ReactComponent };